import React from 'react';
import { Country } from '../../data/countryData';

interface TravelGuideProps {
  country: Country;
}

const TravelGuide: React.FC<TravelGuideProps> = ({ country }) => {
  return(
    <>
      <div>
        <div className='flex flex-wrap'>
          <div className='w-full md:w-2/4 md:pr-8'>
            <h2>{country.name} is best for...</h2>
            <p className='mt-2'>
            {country.bestFor.map((item, index) => (
              <React.Fragment key={index}>
                <span dangerouslySetInnerHTML={{ __html: item }} />
                <br />
              </React.Fragment>
            ))}
            </p>
          </div>

          <div className='w-full h-full md:w-2/4 bg-pink-50 py-8 px-8 md:px-12 rounded-[10px] shadow-xl'>
            <h2>Fast facts for {country.name}</h2>

            <p>
              <span className='font-medium text-black'>Language in {country.name}: </span> <span>{country.fastFacts[0]}</span>
              <br/>
              <span className='font-medium text-black'>Currency in {country.name}: </span> <span>{country.fastFacts[1]}</span>
              <br/>
              <span className='font-medium text-black'>Time Zone in {country.name}: </span> <span>{country.fastFacts[2]}</span>
              <br/>
              <span className='font-medium text-black'>Major Airport in {country.name}: </span> <span>{country.fastFacts[3]}</span>
              <br/>
              <span className='font-medium text-black'>US to {country.name} Flight Duration: </span> <span>{country.fastFacts[4]}</span>
              <br/>
              <span className='font-medium text-black'>Tourism in {country.name}: </span> <span dangerouslySetInnerHTML={{ __html: country.fastFacts[5] }} />
              <br/>
              <span className='font-medium text-black'>Visa & Health Requirements for {country.name}: </span> <span dangerouslySetInnerHTML={{ __html: country.fastFacts[6]}} />
              <br/>
              <span className='font-medium text-black'>Additional Travel Resources for {country.name}: </span> <span dangerouslySetInnerHTML={{ __html: country.fastFacts[7]}} />
            </p>
          </div>
        </div>

        <div className='mt-6'>
        <h2 className='mt-4'>Navigating {country.name}: A Quick Guide</h2>

          <p className='mt-2'>
          {country.gettingAround.map((item, index) => (
            <React.Fragment key={index}>
              <span dangerouslySetInnerHTML={{__html: item}} />
              <br/>
            </React.Fragment>
          ))}
          </p>

        {country.events.length === 0 ? '' : 
          <>
          <h2 className='mt-4'>Events & Festivals in {country.name}</h2>

          <p className='mt-2'>
            {country.events.map((item, index) => (
              <React.Fragment key={index}>
                <span dangerouslySetInnerHTML={{__html: item}} />
                <br/>
              </React.Fragment>
            ))}
          </p>
          </>
        }

          <h2 className='mt-4'>Essential Safety Guide: {country.name}</h2>

            <p className='mt-2'>
              {country.specialDetails.map((item, index) => (
                <React.Fragment key={index}>
                  <span dangerouslySetInnerHTML={{__html: item}} />
                  <br/>
                </React.Fragment>
              ))}
            </p>

          <h2 className='mt-4'>Best time to visit {country.name}</h2>

            <p>
              {country.bestTime}
            </p>
        </div>
      </div>
    </>
  );
};

export default TravelGuide;
